import React, { Component } from "react";
import "./Header.css";
import Clock from "react-live-clock";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="col-md-12 flex-column flex-md-row header">
        <div className="col-md-4">
          <img src="./logo_tmpa.png" alt="logo" />
        </div>
        {this.props.loggedIn === "true" ? (
          <div className="d-flex col-12 col-md-8 align-items-center">
            <div className="col-4 text-center">
              <Clock
                className="clock"
                format={"ddd DD-MM-YYYY HH:mm"}
                ticking={true}
                timezone={"GMT"}
              />
            </div>
            <div className="col-4 text-center">
              {(localStorage.getItem("CanUseMRZ") === "true" || localStorage.getItem("CanAddBGRWithMRZ") === "true") && (
                <div className="scanner-status" onClick={!this.props.port ? this.props.onRequestPort : null} style={{ cursor: !this.props.port ? 'pointer' : 'default', display: 'inline-flex', alignItems: 'center' }}>
                  <div style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: this.props.port ? '#2ecc71' : '#e74c3c',
                    marginRight: '8px',
                    boxShadow: this.props.port ? '0 0 8px #2ecc71' : 'none'
                  }}></div>
                  <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#fff' }}>
                    {this.props.port ? (
                      <span><i className="fa fa-check-circle" style={{ marginRight: '5px' }}></i>Scanner Connected</span>
                    ) : (
                      <span>Connect Scanner</span>
                    )}
                  </span>
                </div>
              )}
            </div>
            <div className="col-4 text-end userCred">
              {"User: "}
              {localStorage.getItem("userid") +
                " / " +
                localStorage.getItem("UserName")}
            </div>
          </div>
        ) : (
          <div className="col-md-2 userCred" />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Header.js